export { formatMoney, formatDate, formatNumber } from './utils.js';
export const SUPPORTED_LOCALES = ['es-AR', 'es', 'en', 'pt-BR', 'es-MX'];
export const DEFAULT_LOCALE = 'es-AR';
export const FALLBACK_LOCALE = 'en';
//# sourceMappingURL=index.js.map